
  import {Component, Vue, Prop} from "vue-property-decorator";
  import {IBook} from "@/interfaces/book.interface";
  import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class SelectParks extends Vue {
    @Prop({}) value!: number[] | null;
    @Prop({}) singleValue!: number | null;
    @Prop({ default: true }) multiple!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: IBook.BookName.parks }) noGroupBook!: string;

    get localValue() { return this.multiple ? this.value : this.singleValue; }
    get usedBooks(): IBook.ParkBookItem[] { return this.$store.getters['book/parksBook']; }

    async mounted() {
      const startValue = this.usedBooks.find(item =>
        this.multiple && this.value && this.value.length && this.value.includes(item.id)
        || !this.multiple && this.singleValue === item.id);
      if (!startValue) {
        await this.$nextTick();
        this.changeValue(this.multiple ? [] : null);
      }
    }

    changeValue(value) {
      this.$emit('input', value === '' ? null : value);
    }
  }
